<script>
    import {onMount} from 'svelte';
    import rpcjs from 'rpcjs';
    const {title, goto} = rpcjs.props;
    title.set('Mission');
    let mainDiv;
    onMount(() => {
        setTimeout(() => {
            ourMis();
        }, 10);
    });

    let ourMission;
    /**
     */
    function ourMis() {
        ourMission.style.bottom = '6vh';
    }
    /**
     * Adds two numbers together.
     */
    function next() {
        mainDiv.style.left = '-100vw';
        setTimeout(()=>{
            goto('/outcomes');
        }, 400);
    }
    /**
     * Adds two numbers together.
     * @param {int} e The first number.
     */
    function keycheck(e) {
        e.preventDefault();
        if (e.key == 'ArrowRight') {
            next();
        }
        if (e.key == 'ArrowLeft') {
            goto('/traction');
        }
    }
</script>

<svelte:window on:keyup={keycheck}/>

<section>
    <div class="maindiv" bind:this={mainDiv}>
        <div class="bgImageWrraper">
            <img
                src="/images/mission/OpusAmbassador.png"
                alt="background"
                class="bg-mission"
            />
        </div>
        <div class="ourMission" bind:this={ourMission}>
            <img
                src="/images/mission/ourMission.png"
                alt="ourMission"
                width="100%"
                height="100%"
            />
        </div>
        <div class="textheading" role="presentation" on:click={next}>
            <div class="tranform">
                <h1>Transfo<br />rmATION</h1>
                <p>
                    Humans are poor at<br /> repetitive tasks.<br />
                    <span> Free them !</span>
                </p>
            </div>
            <div class="resilince">
                <h1>RESILIENCE</h1>
                <p>
                    Change is hard. Inventions and <br />resistance go together.<br
                    />
                    Reinforce positivity.<br />
                    <span>Keep building. <br />Keep moving forward.</span>
                </p>
            </div>
            <div class="invest">
                <h1>INVEST<span>IN</span><br />PEOPLE</h1>
                <p>
                    Cherish and promote <br />unique ideas.<br />
                    <span>Embrace diversity. <br />Think global. </span>
                </p>
            </div>
        </div>
    </div>
</section>

<style>
    section {
        width: 100%;
        height: 100vh;
        overflow: hidden;
        position: relative;
        background-color: #030618; 
    }
    img.bg-mission {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: right;
    }
    .maindiv{
        position: absolute;
        width: 100%;
        height: 100vh;
        overflow: hidden;
        transition-duration: 0.4s;
        left: 0vw;
    }
    .bgImageWrraper {
        width: 100vw;
        height: 100vh; 
    }
    .ourMission {
        left: -2vw;
        bottom: -50vh;
        width: 104.896vw;
        /* height: 36.204vh; */
        height: auto;
        position: absolute;
        transition-duration: 0.5s;
    }
    .textheading {
        position: absolute;
        font-family: "Montserrat";
        font-style: normal;
        height: 100vh;
        width: 100%;
        top: 0vh;
    }
    h1 {
        font-weight: 900;
        font-size: 5.208vw;
        line-height: 78.9%;
        text-align: center;
        text-transform: uppercase;
        color: #ff007f;
        margin: 0;
    }
    p {
        font-weight: 400;
        font-size: 2.083vw;
        line-height: 100%;
        text-align: center;
        color: #ffffff;
        margin: 1vh;
    }
    span {
        font-weight: 900;
        color: white;
        font-size: 2.083vw;
        line-height: 0;
    }
    .tranform {
        position: absolute;
        bottom: 42.8vh;
        left: 11.7vw;
    }
    .resilince {
        position: absolute;
        top: 15.556vh;
        right: 14.323vw;
    }
    .invest {
        position: absolute;
        top: 58.7vh;
        right: 30.5vw;
    }
</style>
